var myModalApp = angular.module('inspinia');

myModalApp.directive('baseSimpleTable', function () {
  return {
    restrict: 'E',
    replace: false,
    transclude: true,
    templateUrl: '/manage/src/view/directive/base_simple_table.html' + '?' + new Date().getTime(),
  };
});
